"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalStudent = exports.HalfLifeStudent = exports.Student = void 0;
//import * as tf from '@tensorflow/tfjs';
const tools_1 = require("./tools");
//import { initial } from 'lodash';
// const prompt = require("prompt-sync")();
class Student {
    constructor(objectives, activities, diff_act, attempt_coef, succ_coef, fail_coef, 
    //attempts_counters: number[][],  
    //succ_counters: number[][],
    //fail_counters: number[][],
    initial_date, ref_date, obj_params
    //environement: boolean = false,
    ) {
        this.activities = {}; // dict : {idObjectif : liste des activités dans l'objectif}
        this.obj_params = {};
        this.objectives = objectives;
        this.activities = activities;
        this.default_params_values = {
            "nb_stay": 3
        };
        if (obj_params) {
            this.obj_params = obj_params;
        }
        this.diff_act = diff_act;
        this.attempt_coef = attempt_coef;
        this.succ_coef = succ_coef;
        this.fail_coef = fail_coef;
        this.initial_date = initial_date; // never used
        this.ref_date = ref_date;
        //this.environement = environement;
        let counters = Array.from(this.objectives, () => []);
        for (let i = 0; i < counters.length; i++) {
            counters[i] = Array.from(this.activities[this.objectives[i]], () => 0);
        }
        this.attempts_counters = counters;
        this.succ_counters = (0, tools_1.deepCopy)(this.attempts_counters);
        this.fail_counters = (0, tools_1.deepCopy)(this.attempts_counters);
        //this.timers = deepCopy(this.attempts_counters);
    }
    dict_idx_ob_act() {
        const d = {};
        let index = 0;
        //for (let seen of this.seen_onces) {fisherDet[seen] /= 2}
        for (let obj of this.objectives) {
            for (let act of this.activities[obj]) {
                d[index] = [obj, act];
                index++;
            }
        }
        return d;
    }
    /*
    set_timer(timer: number[][]): void {
      this.timers = deepCopy(timer);
    }
  
    increment_timer(): void {
      //this.timers = this.timers.map( x => x + 1 );  //increment for 1D-array
      this.timers = this.timers.map((x) => x.map((value) => value + 1));  //increment for 2D-array
    }
  
    reset_timer(objective: string, activity: string, date: Date = undefined): void {
      let ob_id:number = this.objectives.indexOf(objective);
      let act_id:number = this.activities[objective].indexOf(activity);
      this.timers[ob_id][act_id] = 0;
      //this.ref_date[ob_id][act_id] = Date.now();
    }
    */
    reset_ref_date(objective, activity, date) {
        let ob_id = this.objectives.indexOf(objective);
        let act_id = this.activities[objective].indexOf(activity);
        this.ref_date[ob_id][act_id] = date;
        //this.ref_date[ob_id][act_id] = Date.now();
    }
    set_counters(attempts_counters, succ_counters, fail_counters) {
        this.attempts_counters = (0, tools_1.deepCopy)(attempts_counters);
        this.succ_counters = (0, tools_1.deepCopy)(succ_counters);
        this.fail_counters = (0, tools_1.deepCopy)(fail_counters);
    }
    adjust_counters(objective, activity, answer, date) {
        let ob_id = this.objectives.indexOf(objective);
        let act_id = this.activities[objective].indexOf(activity);
        this.attempts_counters[ob_id][act_id]++;
        // === strict equlity?
        if (answer == 1) {
            this.succ_counters[ob_id][act_id]++;
        }
        else {
            this.fail_counters[ob_id][act_id]++;
        }
    }
    add_objective(objective, activities, diff_act, date, params) {
        this.objectives.push(objective);
        this.activities[objective] = activities;
        this.obj_params[objective] = {};
        this.obj_params[objective]["nbturn"] = 0;
        if (params) {
            for (let param_id in params) {
                this.obj_params[objective][param_id] = params[param_id];
            }
        }
        else {
            // creation of default values, need to be cleaned later
            for (let param_id in this.default_params_values) {
                this.obj_params[objective][param_id] = this.default_params_values[param_id];
            }
        }
        //this.timers.push(Array.from(activities, x=>0));
        this.diff_act.push(diff_act);
        this.attempts_counters.push(Array.from(activities, x => 1));
        this.succ_counters.push(Array.from(activities, x => 1));
        this.fail_counters.push(Array.from(activities, x => 0));
        //this.attempt_coef.push(Array.from(activities, x=>this.attempt_coef[0][0]));  
        //this.succ_coef.push(Array.from(activities, x=>this.succ_coef[0][0]));  
        //this.fail_coef.push(Array.from(activities, x=>this.fail_coef[0][0]));
        this.attempt_coef.push(Array.from(activities, x => 0.1)); //coefficients needed to change here
        this.succ_coef.push(Array.from(activities, x => 1)); //coefficients needed to change here
        this.fail_coef.push(Array.from(activities, x => 0)); //coefficients needed to change here
        this.initial_date.push(Array.from(activities, x => date));
        this.ref_date.push(Array.from(activities, x => date));
    }
    add_activity(objective, activity, diff_act, date) {
        if (!(this.objectives.includes(objective))) {
            this.add_objective(objective, Array(activity), [diff_act], date);
        }
        else {
            if (!(this.activities[objective].includes(activity))) {
                let ob_id = this.objectives.indexOf(objective);
                //const old_act = this.activities[objective];
                this.activities[objective].push(activity);
                //this.timers[ob_id].push(0);
                this.diff_act[ob_id].push(diff_act);
                this.attempts_counters[ob_id].push(1);
                this.succ_counters[ob_id].push(1);
                this.fail_counters[ob_id].push(0);
                //this.attempt_coef[ob_id].push(this.attempt_coef[0][0]);
                //this.succ_coef[ob_id].push(this.succ_coef[0][0]);
                //this.fail_coef[ob_id].push(this.fail_coef[0][0]);
                this.attempt_coef[ob_id].push(0.1); //coefficients needed to change here
                this.succ_coef[ob_id].push(1); //coefficients needed to change here
                this.fail_coef[ob_id].push(0); //coefficients needed to change here
                this.initial_date[ob_id].push(date);
                this.ref_date[ob_id].push(date);
            }
        }
    }
    /*
      //external:false or a list of lists of response  all activities
      student_input(objective: string, activity: string, external:any=false): number {
        //let answer: number=0;
        /*
        if (external ==true) {
          // Ask for a response from an external student
          answer = parseInt(prompt('Enter a binary number (0 or 1) from an external student:') || '', 10);
          while (answer !== 0 && answer !== 1) {
            console.log('Try again');
            answer = parseInt(prompt('Enter a binary number (0 or 1) from an external student:') || '', 10);
          }
        } else {
        //Read a response from a list
        //let ob_id = this.objectives.indexOf(objective);
        //let act_id:number = this.activities[objective].indexOf(activity);
        //answer = external[ob_id][act_id];
        }
        if (external ==false) {
          return external;  //studnet answer
        }
        else {
          const answer = parseInt(prompt('Enter your answer: ') || '1', 10);
          return answer;
        }
      }*/
    generate_prob(date = new Date()) {
        return [[]];
    }
    student_answer(objective, activity, date = new Date(), external = false) {
        return 0;
    }
}
exports.Student = Student;
class HalfLifeStudent extends Student {
    constructor(objectives, activities, diff_act, attempt_coef, succ_coef, fail_coef, initial_date, ref_date, obj_params = {}) {
        super(objectives, activities, diff_act, attempt_coef, succ_coef, fail_coef, initial_date, ref_date, obj_params);
    }
    /*constructor(
      ...args:
        [string[],{ [idObj: string]: string[] },number[][],number[][],number[][],number[][], Date[][],Date[][]]){
          super(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]);
        }*/
    generate_prob(date = new Date()) {
        let timerToUse = (0, tools_1.deepCopy)(this.diff_act);
        for (var i = 0; i < this.diff_act.length; i++) {
            for (var j = 0; j < this.diff_act[i].length; j++) {
                timerToUse[i][j] = Math.round(Math.abs((date.valueOf() - this.ref_date[i][j].valueOf()) / (1000 * 60 * 60 * 24 * 7)));
            }
        }
        //console.log(timerToUse);
        /*
        let prob: number[][]=[];
        for (var i = 0; i < this.diff_act.length; i++) {
          for (var j = 0; j < this.diff_act[i].length; j++) {
            prob[i][j]=Math.exp(-timerToUse[i][j] /Math.exp(this.attempt_coef[i][j] * this.attempts_counters[i][j] +
                this.succ_coef[i][j] * this.succ_counters[i][j] + this.fail_coef[i][j] * this.fail_counters[i][j])
            );
          }
        } return prob;*/
        return this.diff_act.map((row, i) => row.map((value, j) => Math.exp(-timerToUse[i][j] /
            Math.exp(value +
                this.attempt_coef[i][j] * this.attempts_counters[i][j] +
                this.succ_coef[i][j] * this.succ_counters[i][j] +
                this.fail_coef[i][j] * this.fail_counters[i][j]))));
    }
    /*
    generate_prob2(): number[][] {
      let res=[];
      for (var i = 0; i < this.diff_act.length; i++) {
        res[i]=[];
        for (var j = 0; j < this.diff_act[i].length; j++) {
          res[i][j] = Math.exp( -this.timers[i][j] /
              Math.exp(this.diff_act[i][j] +
              this.attempt_coef[i][j] * this.attempts_counters[i][j] +
              this.succ_coef[i][j] * this.succ_counters[i][j] +
              this.fail_coef[i][j] * this.fail_counters[i][j])
          );
        }
      }
      return res;
    }
    */
    student_answer(objective, activity, date = new Date()) {
        const prob = this.generate_prob(date);
        let ob_id = this.objectives.indexOf(objective);
        let act_id = this.activities[objective].indexOf(activity);
        const answer = Math.random() < prob[ob_id][act_id] ? 1 : 0; //???
        return answer;
    }
}
exports.HalfLifeStudent = HalfLifeStudent;
class ExternalStudent extends Student {
    constructor(objectives, activities, diff_act, attempt_coef, succ_coef, fail_coef, initial_date, ref_date, obj_params = {}) {
        super(objectives, activities, diff_act, attempt_coef, succ_coef, fail_coef, initial_date, ref_date, obj_params);
    }
    generate_prob(date = new Date(), prob) {
        if (!prob) {
            prob = this.diff_act.map((row) => row.map(() => Math.random()));
        }
        return prob;
    }
    student_answer(objective, activity, date = new Date()) {
        const prob = this.generate_prob(date);
        let ob_id = this.objectives.indexOf(objective);
        let act_id = this.activities[objective].indexOf(activity);
        const answer = Math.random() < prob[ob_id][act_id] ? 1 : 0; //???
        return answer;
    }
}
exports.ExternalStudent = ExternalStudent;
